import api from "../../api/api";

export const TASKBOARD_FETCH_SUCCESS = "TASKBOARD_FETCH_SUCCESS";
export const TASKBOARD_SET_PROJECTS = "TASKBOARD_SET_PROJECTS";
export const TASKBOARD_ADD_TASK = "TASKBOARD_ADD_TASK";
export const TASKBOARD_UPDATE_TASK = "TASKBOARD_UPDATE_TASK";
export const TASKBOARD_DELETE_TASK = "TASKBOARD_DELETE_TASK";
export const TASKBOARD_ADD_PROJECT = "TASKBOARD_ADD_PROJECT";
export const TASKBOARD_DELETE_PROJECT = "TASKBOARD_DELETE_PROJECT";
export const TASKBOARD_UPDATE_PROJECT = "TASKBOARD_UPDATE_PROJECT";

export const fetchTaskBoard = (includeArchivedTasks = false, includeArchivedProjects = false) => async (dispatch: Function) => {
  const [tasks, projects] = await Promise.all([
    api.taskBoard.fetchTasks(includeArchivedTasks),
    api.taskBoard.fetchProjects(includeArchivedProjects),
  ]);
  dispatch({ type: TASKBOARD_FETCH_SUCCESS, payload: { tasks, projects } });
};

export const createTask = (task: any) => async (dispatch: Function) => {
  const created = await api.taskBoard.createTask(task);
  dispatch({ type: TASKBOARD_ADD_TASK, payload: { task: created } });
  return created;
};

export const updateTask = (id: number, fields: any) => async (dispatch: Function) => {
  const updated = await api.taskBoard.updateTask(id, fields);
  dispatch({ type: TASKBOARD_UPDATE_TASK, payload: { task: updated } });
  return updated;
};

export const deleteTask = (id: number) => async (dispatch: Function) => {
  await api.taskBoard.deleteTask(id);
  dispatch({ type: TASKBOARD_DELETE_TASK, payload: { id } });
};

export const archiveTask = (id: number) => async (dispatch: Function) => {
  await api.taskBoard.updateTask(id, { archived: true });
  dispatch({ type: TASKBOARD_DELETE_TASK, payload: { id } });
};

export const createProject = (name: string) => async (dispatch: Function) => {
  const project = await api.taskBoard.createProject(name);
  dispatch({ type: TASKBOARD_ADD_PROJECT, payload: { project } });
  return project;
};

export const deleteProject = (id: number) => async (dispatch: Function) => {
  await api.taskBoard.deleteProject(id);
  dispatch({ type: TASKBOARD_DELETE_PROJECT, payload: { id } });
};

export const unarchiveProject = (id: number) => async (dispatch: Function) => {
  const project = await api.taskBoard.updateProject(id, { archived: false });
  dispatch({ type: TASKBOARD_UPDATE_PROJECT, payload: { project } });
  return project;
};

export const renameProject = (id: number, name: string) => async (dispatch: Function) => {
  const project = await api.taskBoard.updateProject(id, { name });
  dispatch({ type: TASKBOARD_UPDATE_PROJECT, payload: { project } });
  return project;
};
